// extracted by mini-css-extract-plugin
export default {"markdown":"MarkdownMessage_markdown__rsg4z"};